module.exports = __webpack_public_path__ + "img/course_description.e92efc58.jpg";